import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Button,
} from "@mui/material";
import {
  SaveTestCategory,
  UpdateTestCategory,
} from "../../../../services/TestLibService";
import { NotificationManager } from "react-notifications";

const AddTestCategory = ({ open, onClose, onSave, selectedCategory }) => {
  const [testCategory, setTestCategory] = useState("");
  const [glCode, setGlCode] = useState("");

  useEffect(() => {
    if (selectedCategory) {
      setTestCategory(selectedCategory.testCategory || "");
      setGlCode(selectedCategory.glCode || "");
    } else {
      setTestCategory("");
      setGlCode("");
    }
  }, [selectedCategory]);

  const handleSave = async () => {
    try {
      const categoryData = { testCategory, glCode };
      let response;

      if (selectedCategory) {
        response = await UpdateTestCategory(categoryData);
        NotificationManager.success("Test category updated successfully");
      } else {
        response = await SaveTestCategory(categoryData);
        NotificationManager.success("Test category saved successfully");
      }
      
      if (response.status===200) {
        onSave();
        onClose();
      } else {
        NotificationManager.error("Error saving test category");
      }
    } catch (error) {
      NotificationManager.error("Error saving test category");
    }
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        {selectedCategory ? "Update Test Category" : "Add New Test Category"}
      </DialogTitle>
      <DialogContent>
        <TextField
          label="Test Category"
          value={testCategory}
          onChange={(e) => setTestCategory(e.target.value)}
          fullWidth
          margin="dense"
          variant="outlined"
          InputProps={{
            readOnly: selectedCategory ? true : false,
          }}
        />
        <TextField
          label="GL Code"
          value={glCode}
          onChange={(e) => setGlCode(e.target.value)}
          fullWidth
          margin="dense"
          variant="outlined"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} color="secondary">
          Cancel
        </Button>
        <Button onClick={handleSave} variant="contained" color="primary">
          {selectedCategory ? "Update" : "Save"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddTestCategory;
